var map = {
	"./close.png": 34,
	"./codepen.png": 35,
	"./commas.png": 36,
	"./creativity.png": 37,
	"./facebook.png": 38,
	"./flag.png": 39,
	"./github.png": 40,
	"./gmail.png": 41,
	"./home.png": 42,
	"./instagram.png": 43,
	"./inverted-commas.png": 44,
	"./logo.png": 45,
	"./menu.png": 46,
	"./next.png": 47,
	"./pen.png": 48,
	"./prev.png": 49,
	"./start-up.png": 50,
	"./user.png": 51
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33;